<template>
    <section class="pl-3 pr-3">
        <y-row class="share-post d-flex justify-content-between align-items-center pt-8 pb-8 mt-4 ">
            <y-col
                md="6"
                class=" pa-0"
            >
                <div
                    v-if="shortLink"
                    class="d-inline-flex pl-4 share-post__short-link"
                >
                    <div class="share-post__short-link__inner d-inline-flex justify-content-start pt-1 pr-2 pb-1 pl-2 align-items-center">
                        <span class="typo-caption-2 share-post__short-link__title ml-2">{{ $t('blog.short_link') }}</span>
                        <span class="typo-caption-2 share-post__short-link__link">{{ shortLink }}</span>
                        <y-copy-value
                            class="share-post__short-link__icon mr-2"
                            :value="shortLink"
                            icon="copy"
                            icon-prefix="far"
                            icon-size="tiny"
                            :copied-text="$t('blog.copy_value.copied')"
                            :error-text="$t('blog.copy_value.error')"
                        />
                    </div>
                </div>
            </y-col>
            <y-col
                md="6"
                class="share-post__socials d-inline-flex justify-content-end pa-0"
            >
                <div class="share-post__socials__inner pr-5 d-flex justify-content-start align-items-center">
                    <span class="share-post__socials__title typo-caption-1">{{ `${$t('blog.share')}: ` }}</span>
                    <y-socials
                        class="d-flex share-post__socials__items"
                        :twitter="$settings('socials').twitter"
                        :whatsapp="$settings('socials').whatsapp"
                        :telegram="$settings('socials').telegram"
                        :facebook="$settings('socials').facebook"
                        color="primary"
                        size="xsmall"
                        :share="share"
                    />
                </div>
            </y-col>
        </y-row>
    </section>
</template>

<script>
    import { YSocials, YCopyValue } from '@components/index';

    export default {
        name: 'Share',
        
        components: {
            YSocials,
            YCopyValue,
        },
        
        props: {
            /**
             * Add Short Link
             */
            shortLink: String,

            /**
             * title of post
             */
            title: String,
        },

        computed: {
            /**
             * Return Share data
             *
             * @returns {object}
             */
            share() {
                return {
                    url  : window.location.href,
                    title: this.title,
                };
            },
        },
    };
</script>

<style lang="scss" src="./index.scss" />
